import { render } from "./passwordInput.vue?vue&type=template&id=155a0442&scoped=true&ts=true"
import script from "./passwordInput.vue?vue&type=script&lang=ts"
export * from "./passwordInput.vue?vue&type=script&lang=ts"

import "./passwordInput.vue?vue&type=style&index=0&id=155a0442&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-155a0442"]])

export default __exports__